import type { RefObject } from 'react';
import React, { useRef, useCallback } from 'react';
import { SectionRefsContext } from './SectionRefsContext';

type SectionRefsProviderProps = {
  children: React.ReactNode;
};

export const SectionRefsProvider = ({ children }: SectionRefsProviderProps) => {
  const sectionRefsMap = useRef(new Map<string, RefObject<HTMLDivElement>>());

  const registerSectionRef = useCallback((sectionId: string, ref: RefObject<HTMLDivElement>) => {
    sectionRefsMap.current.set(sectionId, ref);
  }, []);

  const getSectionRef = useCallback((sectionId: string) => {
    return sectionRefsMap.current.get(sectionId);
  }, []);

  return (
    <SectionRefsContext.Provider
      value={{
        registerSectionRef,
        getSectionRef,
        sectionRefs: Array.from(sectionRefsMap.current.values()),
      }}
    >
      {children}
    </SectionRefsContext.Provider>
  );
};
